import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function getDailyCategorySales(dateFrom, dateTo, groupBy = 'use_case') {
  const res = await axios.get(`${API_BASE}/category-sales/daily`, {
    headers: authHeader(),
    params: { date_from: dateFrom, date_to: dateTo, group_by: groupBy },
  });
  return res.data;
}
